<template>
    <div :id="winId"
         class="float-window"
         :class="pinned ? 'pinned' : ''"
         :style="{ top: showTop, left: showLeft }"
         @mouseenter="onHover"
         @mouseleave="onDisHover">
        <div class="title-bar"
             @mousedown="onMousedownOnTitlebar">{{ title }}
            <div class="pin-button"
                 @click="togglePinned">
                <div v-if="pinned"
                     class="pin-button-icon-pinned">
                    <svg t="1621432324418"
                         class="icon"
                         viewBox="0 0 1024 1024"
                         version="1.1"
                         xmlns="http://www.w3.org/2000/svg"
                         p-id="2796"
                         width="16"
                         height="16">
                        <path d="M393.846154 64.174932l117.454119 0.399843H512.499805l117.454119-0.399843-10.395939 10.395939c-18.89262 18.89262-28.488872 44.982429-26.28973 71.472081l20.292073 250.502148c2.998829 36.68567 18.092932 72.171808 42.483405 99.661069l34.186646 38.684889-122.252245-0.899648-55.478329-0.399844h-0.99961l-55.478329 0.399844-122.452167 0.799687 34.186646-38.684888c24.390472-27.589223 39.484576-62.9754 42.483405-99.66107l20.292074-250.402187c2.199141-26.589613-7.397111-52.679422-26.289731-71.472081l-10.395939-10.395939m281.889887-64.174932h-0.199922L512.399844 0.599766h-0.799688L348.36392 0h-0.199922c-20.891839 0-39.684498 13.494729-45.582194 33.58688-4.098399 13.994533-1.899258 30.887934 17.79305 47.581414l38.584927 38.584927c5.597813 5.597813 8.39672 13.294807 7.796955 21.091761L346.464662 391.247169c-1.899258 23.190941-11.195627 45.08239-26.589613 62.475596l-61.87583 69.872706c-8.696603 9.796173-13.894572 22.291292-14.394377 35.386177-0.299883 8.996486 1.599375 18.89262 8.596642 27.28934 6.897306 8.296759 17.293245 12.894963 27.989067 12.894963h0.299882l175.931277-1.199532 55.178446 422.834831 0.399844 3.098789 0.399844-3.098789 55.178446-422.834831 175.931277 1.199532h0.299882c10.795783 0 21.191722-4.598204 27.989067-12.894963 6.897306-8.39672 8.796564-18.292854 8.596642-27.28934-0.399844-13.094885-5.697774-25.590004-14.394377-35.386177l-61.87583-69.872706c-15.393987-17.393206-24.690355-39.284654-26.589613-62.475596l-20.292074-250.402187c-0.599766-7.796954 2.199141-15.593909 7.796955-21.091761l38.584927-38.584927c19.692308-16.693479 21.891449-33.58688 17.79305-47.581414-5.997657-19.992191-24.790316-33.58688-45.682155-33.58688z"
                              p-id="2797"></path>
                    </svg>
                </div>
                <div v-else
                     class="pin-button-icon-unpinned">
                    <svg t="1621432349583"
                         class="icon"
                         viewBox="0 0 1024 1024"
                         version="1.1"
                         xmlns="http://www.w3.org/2000/svg"
                         p-id="2964"
                         width="16"
                         height="16">
                        <path d="M702.725498 84.067161L822.778602 204.919953l0.099961 0.099961 0.099961 0.099961 0.699727 0.699727 0.099961 0.099961 0.099961 0.099961L944.531043 325.872706h-47.581414c-28.188989 0-54.878563 12.295197-73.071456 33.786802L629.55408 588.170246c-26.789535 31.4877-42.883249 71.472081-45.382272 112.755955l-5.397892 89.265131-340.367044-340.467006 89.265131-5.397891c41.183913-2.499024 81.268255-18.592737 112.755955-45.382273l228.510738-194.324092c21.491605-18.292854 33.786802-44.882468 33.786802-73.071456V84.067161zM690.33034 4.598204c-8.996486 0-18.092932 2.199141-26.389692 6.697384-15.294026 8.39672-27.689184 24.490433-25.19016 55.178446v65.07458c0 9.39633-4.098399 18.292854-11.295588 24.390472L398.944162 350.263178c-21.091761 17.992971-47.481453 28.588832-75.170636 30.288169l-111.25654 6.697384c-15.593909 0.899649-30.588052 6.997267-41.983601 17.693089-7.796954 7.397111-14.594299 17.293245-15.79383 30.288168-1.199531 12.795002 3.698555 25.390082 12.795002 34.486529l0.199922 0.199922 149.541585 147.542366L6.897306 1021.001171l-2.299102 2.998829 2.998828-2.299102 403.542367-310.378758 147.542366 149.541585 0.199922 0.199922c8.196798 8.196798 19.192503 12.994924 30.688012 12.994924 1.299492 0 2.598985-0.099961 3.798517-0.199922 12.894963-1.199531 22.891058-7.996876 30.288168-15.793831 10.695822-11.395549 16.79344-26.389692 17.693089-41.9836l6.697384-111.25654c1.699336-27.689184 12.295197-54.078875 30.288168-75.170637L872.659118 401.143303c6.097618-7.197189 14.994143-11.295588 24.390472-11.295587h65.07458c2.698946 0.199922 5.29793 0.299883 7.796955 0.299883 25.689965 0 39.784459-11.49551 47.381491-25.490043 11.995314-21.891449 7.497071-49.180789-10.096056-66.773917l-0.099961-0.099961-138.245998-137.346349-0.699726-0.699727L730.814526 21.591566l-0.099961-0.099961c-10.995705-10.995705-25.590004-16.893401-40.384225-16.893401z"
                              p-id="2965"></path>
                    </svg>
                </div>
            </div>
        </div>
        <div class="body">
            <slot name="window-content"></slot>
        </div>
        <div class="triangle"
             :style="{ left: (triangleLeft - 12) + 'px' }"></div>
    </div>
</template>

<script>
export class VdcFloatWindowController {
    _callbacks = new Map();
    _pointPixelTranslator;
    point = null;

    setTitle (title) {
        this.fire('set-title', title);
    }

    show () {
        this.fire('visiablity', true);
    }
    hide (point) {
        this.fire('visiablity', false, this._pointPixelTranslator(point));
    }
    moveTo (pixel) {
        this.fire('moveTo', pixel);
    }
    usePointPixelTranslator (translator) {
        this._pointPixelTranslator = translator;
    }
    moveToInPoint (point) {
        this.point = point;
        this.adjustPosition();
    }
    adjustPosition () {
        if (this.point) {
            const pixel = this._pointPixelTranslator(this.point);
            this.fire('moveTo', pixel);
        }
    }
    setOffset (pixel) {
        this.fire('offset', pixel);
    }

    fire (eventName, ...payload) {
        const _callback = this._callbacks.get(eventName);
        if (_callback) {
            _callback(...payload);
        }
    }

    listen (eventName, callback) {
        this._callbacks.set(eventName, callback);
    }

    unlisten () {
        this._callbacks = new Map();
    }
}

const HIDDEN_DISTANCE = -10000;
export default {
    name: 'vdc-float-window',
    mounted () {
        // DEBUG: 调试时用
        const mapEle = document.getElementById(this.mapId);
        this.offset = mapEle ? mapEle.getBoundingClientRect() : '';

        this.visiablity = this.controller.visiablity;

        this.controller.listen('set-title', (title) => {
            this.title = title;
        });

        this.controller.listen('moveTo', (pixel) => {
            // 如果是 pinned 时，不移动
            if (this.pinned) {
                return;
            }

            this.offset = mapEle.getBoundingClientRect();

            // console.log("offset in moveTo", this.offset);

            const eleWin = document.getElementById(this.winId);
            const rect = eleWin.getBoundingClientRect();
            // console.log("eleWin rect", rect.width, rect.height);

            // console.log("offset", this.offset, "top", this.posTop, "left", this.posLeft);

            this.pixel = pixel;
            this.triangleLeft = rect.width / 2;
            this.posTop = pixel.y - rect.height - 30;
            this.posLeft = pixel.x - this.triangleLeft;
        });
        this.controller.listen('visiablity', (visiablity, pixel) => {
            if (!visiablity) {
                setTimeout(() => {
                    if (!this.isHover && !this.pinned && (pixel.x === this.pixel.x && pixel.y === this.pixel.y)) {
                        this.visiablity = visiablity;
                    }
                }, 500);
            } else {
                this.visiablity = visiablity;
            }
        });
        this.controller.listen('offset', (offset) => {
            this.offset = offset;
        });
    },
    destroyed () {
        this.controller.unlisten();
    },
    data () {
        return {
            title: '详细信息',
            winId: 'ptWinId-' + parseInt(Date.now() + Math.random()),
            isHover: false,
            visiablity: false,
            pinned: false,
            offset: { x: 0, y: 0 },
            pixel: { x: 0, y: 0 },
            posTop: HIDDEN_DISTANCE,
            posLeft: 0,
            triangleLeft: 20
        };
    },
    props: {
        mapId: String,
        controller: VdcFloatWindowController
    },
    computed: {
        showTop: function () {
            if (this.visiablity) {
                if (this.pixel.y < 0) {
                    return HIDDEN_DISTANCE + 'px';
                }
                return (this.offset.y + this.posTop) + 'px';
            } else {
                return HIDDEN_DISTANCE + 'px';
                // if (this.pixel.y < 0) {
                //     return HIDDEN_DISTANCE + 'px';
                // }
                // return (this.offset.y + this.posTop) + 'px';
            }
        },
        showLeft: function () {
            if (this.pixel.x < 0) {
                return HIDDEN_DISTANCE + 'px';
            }
            return this.offset.x + this.posLeft + 'px';
        }
    },
    methods: {
        onHover () {
            // console.log('onHover');
            this.isHover = true;
        },
        onDisHover () {
            // console.log('onDisHover');
            this.isHover = false;
            if (!this.pinned) {
                this.visiablity = false;
            }
        },

        togglePinned () {
            this.pinned = !this.pinned;
        },

        // 实现拖动效果
        onMousedownOnTitlebar (e) {
            // 没有 pinned 时，不许拖动
            if (!this.pinned) {
                return false;
            }

            /// 记录初始位置
            // - 窗口初始位置
            const x0 = this.posLeft;
            const y0 = this.posTop;
            // - 事件初始位置
            const ex0 = e.clientX;
            const ey0 = e.clientY;

            // 鼠标移动的函数
            // 把事件加在 document 上，解决因为鼠标移动太快时，
            // 鼠标超过 eleWin 后就没有了拖拽的效果的问题
            const onMousemove = (e) => {
                // 事件位置 diff
                const dx = e.clientX - ex0;
                const dy = e.clientY - ey0;

                // 根据事件位置 diff 调整窗口位置
                this.posLeft = x0 + dx;
                this.posTop = y0 + dy;
            };
            document.addEventListener('mousemove', onMousemove);

            // 鼠标抬起的函数
            const onMouseup = () => {
                document.removeEventListener('mousemove', onMousemove);
                document.removeEventListener('mouseup', onMouseup);
            };
            document.addEventListener('mouseup', onMouseup);
            // 火狐浏览器在拖拽空div时会出现bug
            // return false 阻止默认事件，解决火狐的bug
            return false;
        }
    }
};
</script>

<style scoped lang="less">
.float-window {
    position: fixed;
    border: 1px solid silver;
    background-color: white;

    border-radius: 4px;

    min-width: 100px;

    z-index: 999;

    left: 100px;
    top: 100px;
    width: 66%;

    .title-bar {
        background-color: #f6f6f7;
        color: #666;
        font-size: 13.4px;

        user-select: none;

        border-top-left-radius: 4px;
        border-top-right-radius: 4px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2px 10px;

        .pin-button {
            cursor: pointer;

            .pin-button-icon-pinned {
                transform: translateY(3px);
            }

            .pin-button-icon-unpinned {
                transform: scale(0.82) translateY(3px);
            }
        }
    }

    &.pinned .title-bar {
        cursor: move;
    }

    &.pinned .pin-button {
        color: red;
    }

    &.pinned .triangle {
        opacity: 0;
    }

    .triangle {
        position: absolute;
        bottom: -12px;
        left: 20px;
        transform: translate(-10px, 7px);
        border-top: 20px solid white;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
    }
}
</style>
